import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
    Toolbar,
    Grid,
    Button,
    Typography,
    Link,
    AppBar
} from '@material-ui/core';

import { useSelector, useDispatch } from 'react-redux'

import { PagesRoles } from '../../../role/PagesRoles'
import { getPerfilUsuario } from '../../../serviceAPI/user'
import { decrypted } from '../../../util/CryptoUtil'
import MenuListUser from '../../../components/MenuListUser';

import LogoBranco from '../../../assets/images/logobranco.png'

const useStyles = makeStyles((theme) => ({
    toolbar: {
        // borderBottom: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    toolbarTitle: {
        flex: 1,
    },
    toolbarSecondary: {
        justifyContent: 'flex-start',
        overflowX: 'auto',
        backgroundColor: '#FFF',
    },
    toolbarLink: {
        padding: theme.spacing(1),
        flexShrink: 0,
    },
}));


export default function Header(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { pageName } = props;

    const token = localStorage.getItem(process.env.REACT_APP_TOKENUSER)
    const roleEncrypt = localStorage.getItem(process.env.REACT_APP_ROLEUSER)
    const roleUser = useSelector(state => state.role.role_user)
    const pages = PagesRoles(roleUser);

    React.useEffect(() => {
        if (roleUser === '' && roleEncrypt !== null) {
            const roleDecrypt = decrypted(roleEncrypt)
            if (roleDecrypt !== null && roleDecrypt !== '') {
                dispatch({ type: 'SET_ROLE', role_user: roleDecrypt })
            } else {
                if (token !== null) {
                    getPerfilUsuario(dispatch);
                }
            }
        } else if (roleEncrypt === null) {
            getPerfilUsuario(dispatch);
        }
    });


    return (
        <div>
            <React.Fragment>
                <AppBar position="sticky" color="inherit">
                    <Toolbar className={classes.toolbar}>
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="center"
                        >
                            <Grid item xs={4}>
                                <Typography>{pageName}</Typography>
                            </Grid>
                            <Grid container item xs={4} justify="center">
                                <img src={LogoBranco} alt="Logo" width={160} />
                            </Grid>
                            <Grid container item xs={4} justify="flex-end">
                                {token !== null ?
                                    <MenuListUser roleUser={roleUser} />
                                    :
                                    <Button onClick={props.login} size="small">Login</Button>
                                }
                            </Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
                <Toolbar component="nav" variant="dense" className={classes.toolbarSecondary}>
                    {pages.map((page) => (
                        <Link
                            color="inherit"
                            noWrap
                            key={page.title}
                            variant="body2"
                            href={page.url}
                            className={classes.toolbarLink}
                        >
                            {page.title}
                        </Link>
                    ))}
                </Toolbar>
            </React.Fragment>
        </div>
    );
}

Header.propTypes = {
    siteName: PropTypes.string,
};